import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import toast from 'react-hot-toast';

const HostAIDay = () => {
  const [formData, setFormData] = useState({
    name: '',
    organization: '',
    email: '',
    city: '',
    type: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const docRef = await addDoc(collection(db, 'hostEventRequests'), {
        ...formData,
        submittedAt: serverTimestamp(),
        status: 'pending'
      });
      
      console.log('Host event request saved with ID:', docRef.id);
      toast.success('Request submitted successfully! We will contact you soon to discuss hosting AI Day at your organization.');
      
      // Reset form
      setFormData({
        name: '',
        organization: '',
        email: '',
        city: '',
        type: '',
        message: ''
      });
    } catch (error) {
      console.error('Error submitting host request:', error);
      toast.error('Error submitting request. Please try again.');
    }
  };

  return (
    <section id="host" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-outfit font-800 text-black mb-4 text-center">
            Bring AI Day to your University / Company
          </h2>
          
          <div className="w-24 h-1 bg-crimson mx-auto mb-8"></div>

          <p className="text-lg font-outfit font-600 text-gray-700 mb-12 text-center">
            We collaborate with:
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center hover:border-crimson transition-all duration-300 shadow-sm">
              <p className="text-black font-outfit font-600">Universities</p>
            </div>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center hover:border-crimson transition-all duration-300 shadow-sm">
              <p className="text-black font-outfit font-600">Startup hubs</p>
            </div>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center hover:border-crimson transition-all duration-300 shadow-sm">
              <p className="text-black font-outfit font-600">Innovation labs</p>
            </div>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center hover:border-crimson transition-all duration-300 shadow-sm">
              <p className="text-black font-outfit font-600">Developer communities</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="bg-gray-50 border border-gray-200 rounded-lg p-8 shadow-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="name" className="block text-black font-outfit font-600 mb-2">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full bg-white border border-gray-300 rounded px-4 py-3 text-black font-outfit font-600 focus:outline-none focus:border-crimson transition-colors"
                  placeholder="Your full name"
                />
              </div>

              <div>
                <label htmlFor="organization" className="block text-black font-outfit font-600 mb-2">
                  Organization / Institution
                </label>
                <input
                  type="text"
                  id="organization"
                  name="organization"
                  value={formData.organization}
                  onChange={handleChange}
                  required
                  className="w-full bg-white border border-gray-300 rounded px-4 py-3 text-black font-outfit font-600 focus:outline-none focus:border-crimson transition-colors"
                  placeholder="Organization name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-black font-outfit font-600 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full bg-white border border-gray-300 rounded px-4 py-3 text-black font-outfit font-600 focus:outline-none focus:border-crimson transition-colors"
                  placeholder="your@email.com"
                />
              </div>

              <div>
                <label htmlFor="city" className="block text-black font-outfit font-600 mb-2">
                  City
                </label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  className="w-full bg-white border border-gray-300 rounded px-4 py-3 text-black font-outfit font-600 focus:outline-none focus:border-crimson transition-colors"
                  placeholder="Your city"
                />
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="type" className="block text-black font-outfit font-600 mb-2">
                Type
              </label>
              <select
                id="type"
                name="type"
                value={formData.type}
                onChange={handleChange}
                required
                className="w-full bg-white border border-gray-300 rounded px-4 py-3 text-black font-outfit font-600 focus:outline-none focus:border-crimson transition-colors"
              >
                <option value="">Select type</option>
                <option value="University">University</option>
                <option value="Corporate">Corporate</option>
                <option value="Community">Community</option>
              </select>
            </div>

            <div className="mb-6">
              <label htmlFor="message" className="block text-black font-outfit font-600 mb-2">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                className="w-full bg-white border border-gray-300 rounded px-4 py-3 text-black font-outfit font-600 focus:outline-none focus:border-crimson transition-colors resize-none"
                placeholder="Tell us about your organization and why you'd like to host AI Day..."
              ></textarea>
            </div>

            <button type="submit" className="btn-primary w-full">
              Request Collaboration
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default HostAIDay;
